import { IGroup } from '../schemas/entity_set'
import { IModelController, ModelController } from '../schemas/structure'
import { IGroupService } from './group_service'
import { MessageBox } from '../helpers/message_box';
import { AppServices } from "../helpers/config_keys";

class GroupsCtrl extends ModelController<IGroup> implements IModelController<IGroup> {
    privileges: Array<string>;

    static $inject = [AppServices.GroupService];

    constructor(private groupService: IGroupService) {
        super("Group")
        this.start()
    }

    saveRecord(role: IGroup) {
        let theGroup = angular.copy(role);
        this.saving = true
        this.groupService.save(theGroup).then((res) => {
            this.saving = false
            this.afterSave(theGroup, res)
        })
    }

    deleteRecord(role: IGroup) {
        MessageBox.confirm(`Delete Group`, `Are you sure you want to delete ${role.name}?`).then((yes) => {
            if (yes) {
                this.deleting = true
                this.groupService.delete(role.id).then((res) => {
                    this.deleting = false
                    this.afterDelete(role, res)
                })
            }
        })
    }

    private loadGroups() {
        this.groupService.get().then((res) => {
            if (res.success) { this.records = res.data }
        })
    }

    private start() {
        this.loadGroups()
    }
}

export { GroupsCtrl }


// WEBPACK FOOTER //
// ./app/address/groups_ctrl.ts